import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    ElementRef,
    inject,
    OnInit,
    Signal,
    viewChild,
    viewChildren
} from "@angular/core";
import {onEach} from '../../utils/observable-utils';
import {MenuModel} from "../menu.model";
import {debounceTime, Subject} from "rxjs";
import {ResponsiveDirective} from "../../responsive/responsive.directive";
import {NgClass} from '@angular/common';
import {ElementWidthDirective} from '../../utils/element-width.directive';
import {ConfigurationModel} from '../../configuration/configuration.model';
import {ActivatableDirective} from '../../ui-elements/activatable.directive';

@Component({
    selector: "woa-menu-subcategory-anchor-panel",
    templateUrl: "./menu-subcategory-anchor-panel.component.html",
    styleUrl: "./menu-subcategory-anchor-panel.component.scss",
    imports: [
        ElementWidthDirective,
        NgClass,
        ResponsiveDirective,
        ActivatableDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuSubcategoryAnchorPanelComponent implements OnInit {
    private destroyRef: DestroyRef = inject(DestroyRef);
    public menuModel: MenuModel = inject(MenuModel);
    public configurationModel: ConfigurationModel = inject(ConfigurationModel);
    public changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

    private readonly scroller: Signal<ElementRef | undefined> = viewChild("scroller");
    private readonly anchors: Signal<ReadonlyArray<ElementRef>> = viewChildren("anchor");

    public scrolling$: Subject<void> = new Subject();

    ngOnInit(): void {
        onEach(this.menuModel.scrollAnchorBar$, (anchorIndex: number) => {
            if (anchorIndex == undefined || !this.scroller()) {
                return;
            }
            const anchor: ElementRef = this.anchors()[anchorIndex];
            if (anchor) {
                this.scroller().nativeElement.scrollTo({
                    left: anchor.nativeElement.offsetLeft - 45,
                    behavior: "smooth"
                });
            }
        }, this.destroyRef);

        // Track the scroller - manually trigger change detection to pick up changes to scroller.scrollLeft as referenced in the template.
        onEach(this.scrolling$.pipe(
            debounceTime(10)
        ), () => this.changeDetectorRef.markForCheck(), this.destroyRef);
    }
}
